import _toConsumableArray from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import { toSafe } from "./_util/arrayIterator.mjs";
import { convertToNumber, roundToFloat16Bits } from "./_util/converter.mjs";
import { DataViewPrototypeGetUint16, DataViewPrototypeSetUint16 } from "./_util/primordials.mjs";
/**
 * returns an unsigned 16-bit float at the specified byte offset from the start of the DataView.
 *
 * @param {DataView} dataView
 * @param {number} byteOffset
 * @param {[boolean]} opts
 * @returns {number}
 */

export function getFloat16(dataView, byteOffset) {
  for (var _len = arguments.length, opts = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    opts[_key - 2] = arguments[_key];
  }

  return convertToNumber(DataViewPrototypeGetUint16.apply(void 0, [dataView, byteOffset].concat(_toConsumableArray(toSafe(opts)))));
}
/**
 * stores an unsigned 16-bit float value at the specified byte offset from the start of the DataView.
 *
 * @param {DataView} dataView
 * @param {number} byteOffset
 * @param {number} value
 * @param {[boolean]} opts
 */

export function setFloat16(dataView, byteOffset, value) {
  for (var _len2 = arguments.length, opts = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    opts[_key2 - 3] = arguments[_key2];
  }

  return DataViewPrototypeSetUint16.apply(void 0, [dataView, byteOffset, roundToFloat16Bits(value)].concat(_toConsumableArray(toSafe(opts))));
}